import { render, staticRenderFns } from "./CloseJobReasonForm.vue?vue&type=template&id=0525d4b2&"
import script from "./CloseJobReasonForm.vue?vue&type=script&lang=js&"
export * from "./CloseJobReasonForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports